import React from "react";

import TtSelect from "./TtSelect";
import TtSelectArray from "./TtSelectArray";
import TtRadio from "./TtRadio";
import TtEmptyArray from "./TtEmptyArray";
import TtRadioButton from "./TtRadioButton";
import TtRadioImg from "./TtRadioImg";
import TtEmail from "./TtEmail";
import Order from "./Order";

export default function Wizard(props) {
  const {
    step,
    data,
    handleChange,
    currentConfig,
    values,
    toIntIf,
    handleChangeArray,
    final,
    setFinal,
  } = props;
  return (
    <div>
      <h2>{step?.title}</h2>
      <p>{step?.text}</p>
      <div className="tt-right">
        {data &&
          data.map((item, k) => {
            if (!item.component) {
              return null;
            }
            const component = item.component;
            return (
              <div key={k}>
                <legend>
                  <h3>{component.label || component.name}</h3>
                </legend>
                {component.type == "Select" && (
                  <TtSelect
                    component={component}
                    handleChange={handleChange}
                    currentConfig={currentConfig}
                    values={values}
                    toIntIf={toIntIf}
                  ></TtSelect>
                )}
                {component.type == "SelectArray" && (
                  <TtSelectArray
                    component={component}
                    handleChangeArray={handleChangeArray}
                    currentConfig={currentConfig}
                    values={values}
                    toIntIf={toIntIf}
                  ></TtSelectArray>
                )}
                {component.type == "EmptyArray" && (
                  <TtEmptyArray
                    component={component}
                    handleChangeArray={handleChangeArray}
                  ></TtEmptyArray>
                )}
                {component.type == "Radio" && (
                  <TtRadio
                    component={component}
                    handleChange={handleChange}
                    currentConfig={currentConfig}
                    values={values}
                    toIntIf={toIntIf}
                  ></TtRadio>
                )}
                {component.type == "RadioImg" && (
                  <TtRadioImg
                    component={component}
                    handleChange={handleChange}
                    currentConfig={currentConfig}
                    values={values}
                    toIntIf={toIntIf}
                  ></TtRadioImg>
                )}
                {component.type == "RadioButton" && (
                  <TtRadioButton
                    component={component}
                    handleChange={handleChange}
                    currentConfig={currentConfig}
                    values={values}
                    toIntIf={toIntIf}
                  ></TtRadioButton>
                )}
                {component.type == "Email" && (
                  <TtEmail
                    component={component}
                    handleChange={handleChange}
                    currentConfig={currentConfig}
                    values={values}
                    toIntIf={toIntIf}
                  ></TtEmail>
                )}
                {component.type == "Order" && (
                  <Order
                    setFinal={setFinal}
                    final={final}
                    currentConfig={currentConfig}
                    show={true}
                    data={data}
                  />
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
